import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CoursesNavbar from "../CoursesNabbar";
import Footer from "../Footer";
import ChapterBox from "../class 10/ChapterBox";
import Noteswritten from "../Noteswritten";
import { Helmet } from "react-helmet";

export default function Computer11() {
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [noPreview, setNoPreview] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ PDF loading state
  const location = useLocation();

  useEffect(() => {
    setSelectedPdf(null);
    setNoPreview(false);
    setLoading(false);
  }, [location.pathname]);

  const getViewerLink = (link) => {
    if (!link) return "";
    // Convert Google Drive preview/download links to embeddable format
    const fileId = link.split("/d/")[1]?.split("/")[0];
    if (!fileId) return "";
    return `https://drive.google.com/file/d/${fileId}/preview`;
  };

  const chapters = [
    { no: 1, name: "Computer System", pdflink: "https://drive.google.com/file/d/1tqHrZLK6dl_uVaYEQO_eewwijF7I3dr2/preview" },
    { no: 2, name: "Number System and Conversion, Boolean Logic", pdflink: "" },
    { no: 3, name: "Computer Software and Operating System", pdflink: "https://docs.google.com/document/d/1YJKljgF1yIjDc5oUo0CKX7q3xhew7hIXhsfGky0Ssqs/preview" },
    { no: 4, name: "Application Package", pdflink: "" },
    { no: 5, name: "Programming Concept And Logic", pdflink: "https://docs.google.com/document/d/1eKm_7c6uGs8NI2E8VY-hekXysRJSZkmUKU7H_Df027I/preview" },
    { no: 6, name: "Web Technology - I (HTML + CSS)", pdflink: "" },
    { no: 7, name: "Multimedia", pdflink: "https://docs.google.com/document/d/17IP2pioy2-Or6fLm3ITDZu7vkxVdqMeNBQv0Bnnwuyc/preview" },
    { no: 8, name: "Information Security And Cyber Law", pdflink: "" },
  ];

  const handleChapterClick = (link) => {
    if (link) {
      setSelectedPdf(link);
      setLoading(true); // start loader
      setNoPreview(false);
    } else {
      setNoPreview(true);
    }
  };

  return (
    <>
    <Helmet>
        <title>Class 11 Computer Science Notes | Online Paathshala</title>
        <meta name="description" content="Access Class 11 Computer Science NEB notes and important questions." />
        <meta property="og:title" content="Class 11 Computer Science Notes | Online Paathshala" />
        <meta property="og:description" content="Access Class 11 Computer Science NEB notes and important questions." />
        <meta property="og:image" content="https://www.onlinepaathshala.com/logo192.png" />
        <meta property="og:url" content="https://onlinepaathshala.com/enotes-class-11/enotes-class-11-computer-science" />
      </Helmet>
      {/* Header */}
      <div className="bg-slate-300 mt-5 pb-3 lg:pb-3 shadow-sm">
        <Noteswritten />
      </div>

      {/* Courses Navbar */}
      <div className="mt-3">
        <CoursesNavbar />
      </div>

      {/* Chapter List */}
      <div className="flex justify-center flex-wrap mt-5 gap-4">
        {chapters.map((chapter) => (
          <div
            key={chapter.no}
            onClick={() => handleChapterClick(chapter.pdflink)}
            className="cursor-pointer flex-1 min-w-[250px] max-w-[280px] flex"
          >
            <ChapterBox chapterNo={chapter.no} chapterName={chapter.name} />
          </div>
        ))}
      </div>

      {/* PDF Viewer Modal */}
      {selectedPdf && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 px-4"
          onClick={() => setSelectedPdf(null)}
        >
          <div
            className="bg-white rounded-lg shadow-lg w-full md:w-4/5 h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <div className="flex justify-end p-2">
              <button
                onClick={() => setSelectedPdf(null)}
                className="px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 transition"
              >
                Close
              </button>
            </div>

            {/* Loader */}
            {loading && (
              <div className="flex-1 flex justify-center items-center bg-gray-100">
                <p className="text-gray-600 font-semibold">Loading PDF...</p>
              </div>
            )}

            {/* PDF iframe */}
            <iframe
              src={getViewerLink(selectedPdf)}
              className={`w-full h-full border border-gray-300 rounded-b-lg bg-white ${loading ? "hidden" : "block"}`}
              title="PDF Viewer"
              onLoad={() => setLoading(false)} // hide loader when ready
            ></iframe>
          </div>
        </div>
      )}

      {/* No Preview Modal */}
      {noPreview && (
        <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50 px-4">
          <div className="bg-white rounded-lg shadow-lg w-80 p-6 flex flex-col items-center">
            <p className="text-gray-700 font-semibold mb-4">No Preview Available</p>
            <button
              onClick={() => setNoPreview(false)}
              className="px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Footer */}
      <div className="mt-[120px]">
        <Footer />
      </div>
    </>
  );
}
